import type { GradeTdsFile } from "../types";

export function revisionLabel(revisionMonth: string | null | undefined): string {
  if (!revisionMonth) return "No revision date";
  const [year, month] = revisionMonth.split("-").map(Number);
  const monthText = new Date(Date.UTC(year, month - 1, 15)).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
  return `Revision ${monthText}`;
}

export interface TdsFileWithCurrent extends GradeTdsFile {
  isCurrent: boolean;
}

export function withCurrentFlags(newestFirstFiles: GradeTdsFile[]): TdsFileWithCurrent[] {
  return newestFirstFiles.map((file, position) => ({ ...file, isCurrent: position === 0 }));
}

export function singleUploadLinks(gradeId: number): string {
  return JSON.stringify([{ fileIndex: 0, gradeId }]);
}
